import { useResubmitExamModal } from 'components/exams/ResubmitExamModalContent/resubmitExamModalContent.hooks';
import { TNotificationFieldsFragment } from 'generated/graphql';
import NotificationActionItem from '../NotificationActionItem';

interface IResubmitExamContent {
  data: TNotificationFieldsFragment;
  onOpen: () => void;
  onCompleted: () => void;
}

const ResubmitExamContent = ({
  data,
  onOpen,
  onCompleted,
}: IResubmitExamContent) => {
  const { openResubmitModal } = useResubmitExamModal({
    onClick: onOpen,
    onCompleted,
  });

  return (
    <NotificationActionItem
      data={data}
      onClick={() => openResubmitModal(data?.exam?._id?.toString() || '')}
    />
  );
};

export default ResubmitExamContent;
